import { LiveopsLeaderboardReward } from '@/modules/liveops/leaderboard/types';
import { LiveopsMilestoneReward } from '@/modules/liveops/milestone/types';

export interface LiveopsOption {
    value: number;
    label: string;
    background?: string;
}

export enum LiveopsType {
    Unknown = 0,
    Normal = 1,
    Arena = 2,
    Duplicate = 3
}

export enum LiveopsStatus {
    Unknown = -1,
    None = 0,
    Enabled = 1,
    Started = 2,
    Closed = 3,
    Ended = 4,
    Disabled = 5
}

export enum LiveopsRewardType {
    Unknown = 0,
    Milestone = 1,
    Leaderboard = 2
}

export interface LiveopsItemModel {
    id: number | null;
    name: string | null;
    type: number | null;
    rewardType: LiveopsRewardType | number | null;
    status: number | null;
    betCosts: string | null;
    startTime: Date | null;
    closeTime: Date | null;
    endTime: Date | null;
    image: string | null;
    imageFile: unknown | null;
    imageStatus: number | null;
    icon: string | null;
    iconFile: unknown | null;
    iconStatus: number | null;

    milestones: LiveopsMilestoneReward[];
    leaderboards: LiveopsLeaderboardReward[];

    canEdit: boolean;
    canEditContent: boolean;
    canEditMilestone: boolean;
    canEditLeaderboard: boolean;
    canEnable: boolean;
    canDisable: boolean;
    canDelete: boolean;
    readonly isBetCostsShown: boolean;
}

export const LiveopsOptions = {
    Type: [
        { value: LiveopsType.Normal, label: 'Normal', background: 'success' },
        { value: LiveopsType.Arena, label: 'Arena', background: 'warning' },
        { value: LiveopsType.Duplicate, label: 'Duplicate', background: 'info' }
    ] as LiveopsOption[],
    Status: [
        { value: LiveopsStatus.None, label: 'None', background: 'secondary' },
        { value: LiveopsStatus.Enabled, label: 'Enabled', background: 'success' },
        { value: LiveopsStatus.Started, label: 'Started', background: 'info' },
        { value: LiveopsStatus.Closed, label: 'Closed', background: 'warning' },
        { value: LiveopsStatus.Ended, label: 'Ended', background: 'danger' },
        { value: LiveopsStatus.Disabled, label: 'Disabled', background: 'danger' }
    ] as LiveopsOption[],
    RewardType: [
        { value: LiveopsRewardType.Milestone, label: 'Milestone' },
        { value: LiveopsRewardType.Leaderboard, label: 'Leaderboard' }
    ] as LiveopsOption[]
};
